import React, { Component } from 'react';
import { routerActions } from 'connected-react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Header, Divider, Button} from 'semantic-ui-react'
import moment from 'moment';
import FacilityInventory from '../../components/FacilityInventory';
import * as Facility from '../../store/Facility';
import * as Events from '../../store/Events';
import * as Venue from '../../store/Venue';
// import * as geo from '../../helpers/geo';

class EventInventory extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChange(e, inventory) {
        console.log(inventory);
        this.setState({[inventory.id]: inventory});
    }
    async onSubmit(e) {
        const {event, actions} = this.props;
        const inventory = Object.values(this.state);
        try {
            await actions.updateInventory({id: event.id, inventory});
            actions.replace('/admin');
        } catch (error) {
            console.log(error);
        }
    }

    render() {
        const {event, venues} = this.props;
        const venue = venues[event.venueId];
        console.log(venue);
        return (
            <div className='event'>
                <Header as='h1' content="Inventory Availability" />
                <Header as='h2' content={`${event.name} - ${moment(event.start).format('L')} to ${moment(event.finish).format('L')}`} />
                <Divider />
                {event.inventory.map((i, index) => (<FacilityInventory inventory={this.state[i.id] || i} onChange={this.onChange} />))}
                <Button primary content='Save Inventory' onClick={this.onSubmit} />
            </div>
        );
    }
}

EventInventory.propTypes = {

};


const mapStateToProps = (state, ownProps) => {
    return {
        facilities: Facility.selector(state).facilities,
        event: Events.selector(state).events[ownProps.match.params.eventId],
        venues: Venue.selector(state).venue
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Facility.actionCreators, dispatch),
        ...bindActionCreators(Events.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventInventory));